import { Button } from '@atoms/Buttons';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

type propTypes = {
    title: string;
    body: any;
    centered?: boolean;
    type?: string;
    buttonStyle?: string;
    buttonText: string;
    size: string;
    element: any;
    disabled?: boolean;
};

const ActionModal = (props: propTypes) => {
    const { title, body, centered, type, buttonStyle, buttonText, size, element, disabled } = props;

    const [modalValue, showModal] = useState(false);

    const handleClick = (flag: boolean) => {
        showModal(flag);
    }
    const onHide = (): void => {
        showModal(false);
    }

    return (
        <ActionModalWithStyled>
            <Button type={type} variant={buttonStyle} size={size} onClick={handleClick} disabled={disabled}>
                {buttonText}
            </Button>

            <Modal centered={centered} show={modalValue} onHide={onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ModalBodyWithStyled className="text-center">
                        <ModalBodyTextWithStyled>
                            {body}
                        </ModalBodyTextWithStyled>
                    </ModalBodyWithStyled>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="btn-secondary" onClick={() => onHide()}>いいえ</Button>
                    <ActionButtonWrapperWithStyled onClick={() => handleClick(false)}>
                        { element }
                    </ActionButtonWrapperWithStyled>
                </Modal.Footer>
            </Modal>
        </ActionModalWithStyled>
    );
};

const ActionModalWithStyled = styled.div`
`;
const ModalBodyWithStyled = styled.div`
`;
const ModalBodyTextWithStyled = styled.p`
`;
const ActionButtonWrapperWithStyled = styled.div`
`;

ActionModal.defaultProps = {
    centered: true,
    size: 'sm',
};

export default ActionModal;